import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

import { Spinner } from '@/components'
import { Routes } from '@/constants'
import { useCurrentUserContext } from '@/contexts/CurrentUserContext'
import useAuth from '@/hooks/useAuth'
import useTracking from '@/hooks/useTracking'

const PublicRoute: React.FC<React.PropsWithChildren> = ({ children }) => {
  const userContext = useCurrentUserContext()
  const [mounted, setMounted] = useState(false)
  const { query, replace, events } = useRouter()
  const { isLogged } = useAuth()
  const { setupPageViewTracking } = useTracking()

  useEffect(setupPageViewTracking, [events, setupPageViewTracking])

  useEffect(() => {
    if (!userContext) return

    if (isLogged() && !query?.redirectUrl) {
      replace(Routes.LEARNING_COMMUNITIES)

      return
    }

    setMounted(true)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userContext])

  if (!mounted)
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner size="md" />
      </div>
    )

  return <>{children}</>
}

export default PublicRoute
